import { Slide } from '@material-ui/core';
import styled from 'styled-components';

export const ModalSlide = styled(Slide)`
  outline: none;
`;
